import React, { useEffect } from 'react';
import clsx from 'clsx';
import { Checkbox } from '@material-ui/core';
import { ServiceDialog, NameTextField,ConfirmButton } from '../../../../../../styling/Styles';
import { getAllComponents } from '../../../../Events/CreateRulesPerPage';
import { extractCss } from '../../../../renderCreatedBlocks';

const CreateBlockPopUp = (props) => {
    const { editor, selectedPage, selectedProject, savedPageClicked } = props;

    const [init, setInit] = React.useState(false);
    const [clickedEdit, setClickedEdit] = React.useState(false);
    const [blockName, setBlockName] = React.useState('');
    const [includeAnns, setIncludeAnns] = React.useState(false);


    useEffect(() => {
        if (init === false && editor.BlockManager !== undefined) {
        editor.Commands.add('create-block', {
            run() {
                setClickedEdit(true);
            }
        });
        setInit(true);
        }
    },[selectedProject,selectedPage]);
  

    useEffect( () => {
        if(clickedEdit === true){
            setBlockName('');
            setIncludeAnns(false);
        }
    },[clickedEdit])

    const handleBlockName = (e) => {
        setBlockName(e.target.value);
    }

    const returnError = () =>{
        
        const blockLabels = document.getElementsByClassName('gjs-block-label');
        const insideBlocksText = new Set();

        Array.prototype.forEach.call(blockLabels, (el) => {
            insideBlocksText.add(el.innerText);
        });

        if(blockName === ''){
            return true;
        }
        if( insideBlocksText.has(blockName)){
            return true;
        }
        return false;
    }
 
    const getInnerHtml = (el) => {
        let str = `<${el.nodeName.toLowerCase()}`;
        
        Array.prototype.forEach.call(el.attributes, (attr) => {
            if(attr.name !== 'annotationname' && attr.name !== 'target_page'){
                str += ` ${attr.name}="${attr.value}"`;    
            }
        });
        str += '>';
        Array.prototype.forEach.call(el.childNodes, (node) => {
            
            if (node.nodeType === 3) {
                str += node.textContent;
            } else {
                str += getInnerHtml(node);
            }
        });
        str += `</${el.nodeName.toLowerCase()}>`;
        return str;
    }

    const createCustomBlock = () => {


        if(returnError() === false){

            setClickedEdit(false);
            const id = editor.getSelected().ccid;
            const tempDoc = document.getElementsByTagName('iframe')[0].contentWindow.document.getElementById(id);
            let blockContent = '';

            if(includeAnns === false){
                blockContent = getInnerHtml(tempDoc);                
            }
            else{
                blockContent = tempDoc.outerHTML;
            }
            blockContent = blockContent.replace(' gjs-selected','');

            const allComps = getAllComponents(editor.getSelected());
            const componentsIds = allComps.map( comp => comp.ccid);
            const tempSelectors = [];
            
            const tempData = JSON.parse(localStorage.getItem('data'));

            JSON.parse(localStorage.getItem('gjs-styles')).forEach( style => {
                style.selectors.forEach( selector => {
                    if( typeof(selector) === 'string' && selector.startsWith('classRule') ){
                        tempSelectors.push(style);
                    }
                })
            });

            const customBlockSelector = [];
            componentsIds.forEach( compId => {
                tempSelectors.forEach( selector => {
                    if( selector.selectors.includes(`classRule-${compId}`)){
                        customBlockSelector.push(selector)
                    }
                })
            })

            tempData[selectedProject].customBlocks.push({ 
                'content':{
                    'id':  blockName,
                    'label': blockName,
                    'content': blockContent,
                    'category': 'Extra '
                },
                'style': customBlockSelector
            })
            localStorage.setItem('data', JSON.stringify(tempData));

            if (editor.BlockManager !== undefined) {
                editor.BlockManager.add(blockName, {
                  label: blockName,
                  content: blockContent + extractCss(customBlockSelector),
                  category: {
                    label: 'Extra ',
                    open: 'true',
                    },
                attributes:{
                    customBlock: true
                }
                });
            }
            savedPageClicked();
        }
    }

    

    const returnHelperText = () => {
        const blockLabels = document.getElementsByClassName('gjs-block-label');
        const insideBlocksText = new Set();

        Array.prototype.forEach.call(blockLabels, (el) => {
            insideBlocksText.add(el.innerText);
        });

        if(blockName === ''){
            return 'empty block name';
        }
        if( insideBlocksText.has(blockName)){
            return 'block name already exists';
        }
        return '';
    }

    return (
        <ServiceDialog
            open={clickedEdit}
            keepMounted
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            id=''
        >
            <div style={{ height: '100%' }}>
            {editor !== undefined &&
            editor.getSelected !== undefined &&
            editor.getSelected() !== undefined && (
                <div className={clsx('titlePopUp', 'paddingTitle')}>
                {' '}
                Create custom block
                <div
                    aria-hidden="true"
                    onClick={() => {
                    setClickedEdit(false);
                    }}
                    className={clsx('pop-up-close-btn')}
                >
                    x
                </div>
                </div>
            )}
                <div
                    className={clsx('paddingTitle')}
                    style={{ height: '90%', overflowY: 'auto', maxHeight: '650px' }}
                >
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <div>
                            Block name :
                            <span style={{marginLeft: '0.6vw'}}>&nbsp;</span>
                            <NameTextField
                                placeholder=' Block name'
                                onInput={e =>handleBlockName(e)}
                                value={blockName}
                                error={returnError()}
                                helperText={returnHelperText()}
                            />
                        </div>
                        <div style={{marginTop: '1rem'}}>
                            <Checkbox  checked={includeAnns} onChange={ () => setIncludeAnns(!includeAnns)}  style={{color: '#0c4d82'}} inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} />
                            &nbsp;&nbsp;
                            Include annotations & actions
                        </div>

                        <div style={{marginTop: '1rem', display: 'flex',justifyContent: 'flex-end' }}>
                            <ConfirmButton onClick={() => createCustomBlock()}> Confirm </ConfirmButton>
                        </div>

                    </div>
                    


                </div>
            </div>
        </ServiceDialog>
    );
};
export default CreateBlockPopUp;